module.exports = __webpack_public_path__ + "prod-assets/laptop-pink-1f09f8.obj";


//////////////////
// WEBPACK FOOTER
// ./assets/laptop-pink.obj
// module id = 21
// module chunks = 0